import { LOCATION_TYPES } from "@circle-react/components/Events/helpers/constants";
import { addYears, endOfYear } from "date-fns";

export const I18N_ROOT = "events.create.form";
export const I18N_EDIT_MODAL_ROOT = "events.edit_modal";

export const TABS = {
  OVERVIEW: "overview",
  PEOPLE: "people",
  BASIC_INFO: "basicInfo",
  NOTIFICATIONS: "notifications",
  PAYMENT: "payment",
  REMINDERS: "reminders",
  ADVANCED: "advanced",
} as const;

export type Tab = (typeof TABS)[keyof typeof TABS];

const EVENT_EDIT_TABS = [
  TABS.OVERVIEW,
  TABS.PEOPLE,
  TABS.BASIC_INFO,
  TABS.NOTIFICATIONS,
  TABS.REMINDERS,
  TABS.ADVANCED,
] as const satisfies readonly Tab[];

const EVENT_CREATE_TABS = [TABS.BASIC_INFO] as const satisfies readonly Tab[];

const EVENT_EDIT_TABS_WITH_PAYMENT = [
  TABS.OVERVIEW,
  TABS.PEOPLE,
  TABS.BASIC_INFO,
  TABS.NOTIFICATIONS,
  TABS.PAYMENT,
  TABS.REMINDERS,
  TABS.ADVANCED,
] as const satisfies readonly Tab[];

const FLAGGED_TAB_ALIASES: Record<string, Tab> = {
  details: TABS.BASIC_INFO,
  email: TABS.REMINDERS,
  advancedOptions: TABS.ADVANCED,
};

export const getEventModalTabs = ({
  canManageEventPayments,
  isEditMode,
  isEventsBuilderEnabled,
}: {
  canManageEventPayments: boolean;
  isEditMode: boolean;
  isEventsBuilderEnabled: boolean;
}): readonly Tab[] => {
  if (!isEditMode) {
    return EVENT_CREATE_TABS;
  }

  return isEventsBuilderEnabled && canManageEventPayments
    ? EVENT_EDIT_TABS_WITH_PAYMENT
    : EVENT_EDIT_TABS;
};

export const normalizeEventModalTab = ({
  tab,
  tabs,
  isEventsBuilderEnabled,
}: {
  tab?: string;
  tabs: readonly Tab[];
  isEventsBuilderEnabled: boolean;
}): Tab => {
  const normalizedTab = isEventsBuilderEnabled
    ? (FLAGGED_TAB_ALIASES[tab ?? ""] ?? tab)
    : tab;

  return tabs.find(candidate => candidate === normalizedTab) ?? TABS.BASIC_INFO;
};
export const TICKET_TYPES = { PAID: "paid", FREE: "free" } as const;
export const LIVE_LOCATION_TYPES = [
  LOCATION_TYPES.LIVE_ROOM,
  LOCATION_TYPES.LIVE_STREAM,
] as const;
export const STATUS = { PUBLISHED: "published", DRAFT: "draft" } as const;
export const EVENT_SETTING_ATTRS = "event_setting_attributes";
export const RECURRING_EDIT_MODE = {
  CURRENT: "current",
  REMAINING: "remaining",
  ALL: "all",
} as const;

export type RecurringEditMode =
  (typeof RECURRING_EDIT_MODE)[keyof typeof RECURRING_EDIT_MODE];

export const STATS_PREVIEW_COUNT = 3;
// MySQL MEDIUMTEXT column max byte size (2^24 - 1).
export const MAX_PAYWALL_DESCRIPTION_LENGTH = 16777215;

const GENERIC_FUTURE_DATE_YEARS = 10;

export const getGenericFutureDate = () =>
  endOfYear(addYears(new Date(), GENERIC_FUTURE_DATE_YEARS));
